<template>
    <div class="wrapper d-flex flex-column min-vh-100">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DWrapper'
}
</script>
